import styled from 'styled-components';

export const ImageWrapper = styled.div`
  width: 160px;
  height: 150px;
  border: 1px solid ${(props) => (props.isSelected ? '#283618' : 'transparent')};
  border-radius: 0;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  opacity: ${(props) => (props.isSelected ? '1' : '0.3')};

  img {
    width: 100%;
    height: calc(100% - 25px); // Adjust for city name space
    object-fit: contain;
  }

  &:hover {
    border-color: #283618;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: opacity 0.2s ease;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
`;
